<template>
  <div class="order">
    <Detail />
    <div
      style="
        margin-top: 20px;
        border-radius: 20px;
        box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
        padding: 20px 10px;
      "
    >
      <div style="color: #0083ff; font-size: 18px; text-align: center">
        默认支付密码：123456
      </div>
      <van-cell-group>
        <van-field
          style="
            margin: 20px 0;
            border-radius: 40px;
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
          "
          v-model="password"
          required
          @blur="dd"
          type="number"
          maxlength="6"
          placeholder="请输入原支付密码"
          :error-message="errors"
        />
        <van-field
          v-model="passwords"
          style="
            margin: 20px 0;
            border-radius: 40px;
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
          "
          required
          @blur="cc"
          type="number"
          maxlength="6"
          placeholder="请输入新支付密码"
          :error-message="errores"
        />
        <van-field
          v-model="passwordes"
          style="
            margin: 20px 0;
            border-radius: 40px;
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
          "
          required
          @blur="ss"
          type="number"
          maxlength="6"
          placeholder="请输入确认新支付密码"
          :error-message="error"
        />
      </van-cell-group>
      <van-button
        style="margin: 20px 0; width: 100%"
        size="medium"
        round
        type="info"
        :disabled="passwords !== passwordes"
        @click="updatePayPassWord"
      >
        修改密码
      </van-button>
    </div>
  </div>
</template>

<script>
  // // import { Loading } from "element-ui";
  import { updatePayPassWord } from "@/api/cardOperation";
  import Detail from "@/components/Detail.vue";
  export default {
    data() {
      return {
        sms: "",
        tel: "",
        password: "",
        passwords: "",
        passwordes: "",
        error: "",
        errors: "",
        errores: "",
      };
    },
    created() {},
    methods: {
      updatePayPassWord() {
        if (
          this.password == "" &&
          this.passwords == "" &&
          this.passwordes == ""
        ) {
          this.$notify({ type: "warning", message: `必填项不能为空` });
        } else {
          updatePayPassWord(this.password, this.passwords).then((res) => {
            if (res.status) {
              this.$notify({ type: "success", message: res.msg });
            } else {
              this.$notify({ type: "warning", message: res.msg });
            }
          });
        }
      },
      dd() {
        if (this.password === "") {
          this.errors = "密码不能为空";
        } else {
          this.errors = "";
        }
      },
      cc() {
        if (this.passwords === "") {
          this.errores = "密码不能为空";
        } else {
          this.errores = "";
        }
      },
      ss() {
        if (this.passwords === this.passwordes) {
          this.error = "";
        } else {
          this.error = "请确认密码一致";
        }
      },
    },

    components: {
      Detail,
    },
  };
</script>

<style lang="scss" scoped>
  .order {
    // background-color: rgba(128, 128, 128, 0.1);
    padding: 20px;
    .detail {
      width: 100%;
      margin: 20px 0;
      border-radius: 20px;
      padding-top: 10px;
      padding-bottom: 20px;
      box-sizing: border-box;
      box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
      background-color: rgba(128, 128, 128, 0.1);
    }
  }
</style>
